<script>
	import Input from "./components/Input.svelte";
	import Content from "./components/Content.svelte";

	export let query = 'all';

	export const getTerms = async () => {
		var response = await fetch('https://carpedictionary.eric-beltermann.de/api/terms.php?string=' + query);
		var result = await response.json();
		return result;
	}
	
	let promise = getTerms();


	export function search () {
		console.log(this.value)
		query = this.value;
		promise = getTerms();
	}

</script>

<Input 	
				search={search} />



{#await promise}
await
{:then data}
	<div class="wrapper">
		

		<Content 	data={data} 
					query={query} />
	</div>
	<img src="assets/images/aushunlgbtnatomasonry.jpg">
{:catch err}
	<h2>Error while loading the data</h2>
{/await}

<style lang="scss">
	@import "./main.scss";

	.wrapper {
		// max-width: 620px;
		margin: 0 auto;
	}

	img {
		max-width: 100%;
		width: 320px;
		display: block;
		margin: 0 auto;
	}

</style>

